<div class="input-group">

  <span class="input-group-addon">
    <i class="glyphicon glyphicon-search"></i>
  </span>

  <ng-template #searchResultTemplate let-result="item" let-index="index">
    <table style="width: 95%; position: relative">
      <tr style="width: 100%">
        <td style="min-width: 70%">
          {{ result.name }}
        </td>
      </tr>
    </table>
  </ng-template>

  <input #userSearchInput
         type="text"
         class="form-control"
         style="width: 300px"
         placeholder="Enter user name"
         autocomplete="off"
         typeaheadOptionField="name"
         [typeaheadMinLength]="0"
         [ngModel]="selectedUser.name"
         [typeahead]="foundUsers$"
         [typeaheadAsync]="true"
         [typeaheadItemTemplate]="searchResultTemplate"
         (typeaheadOnSelect)="onSelect($event)"/>
</div>
